module.exports = __webpack_public_path__ + "static/img/video.e941f2b0.gif";